import React, { Component } from 'react';
import PropTypes from 'prop-types';
import {
  Button,
  Grid,
  Modal,
  Input,
} from '../../../src/components/index';

class ModalRetornoFilaGet extends Component {
  modalContent = () => (
    <React.Fragment>
      <div className="row">
        <Grid cols="12 12 12 12">
          <Input
            style={{ color: '#00314d' }}
            disabled
            cols="80"
            componentClass="textarea"
            label="URL"
            maxlength="200"
            rows="2"
            value={this.props.retornoFilaGet.url}
            textarea
          />
        </Grid>
      </div>
      <div className="row">
        <Grid cols="12 12 12 12">
          <Input
            style={{ color: '#00314d' }}
            disabled
            cols="80"
            componentClass="textarea"
            label="Body Envio"
            maxlength="200"
            rows="6"
            value={this.props.retornoFilaGet.bodyEnvio}
            textarea
          />
        </Grid>
      </div>
      <div className="row">
        <Grid cols="12 12 12 12">
          <Input
            style={{ color: '#00314d' }}
            disabled
            cols="80"
            componentClass="textarea"
            label="Retorno"
            maxlength="200"
            rows="6"
            value={this.props.retornoFilaGet.retorno}
            textarea
          />
        </Grid>
      </div>
    </React.Fragment>
  )

  modalFooter = () => (
    <React.Fragment>
      <div className="right">
        <Button
          title="Fechar"
          onClick={this.handleClose}
          hint="Fechar"
        />
      </div>
    </React.Fragment>
  )

  handleClose = () => {
    this.setState(this.props.handleModal('showAlteracaoValorMedioBeneficioModal'));
  }

  render() {
    return (
      <Modal
        {...this.props}
        conteudofooter={this.modalFooter()}
        conteudomodal={this.modalContent()}
        onHide={this.handleClose}
        size="lg"
        showModal={this.props.showModal}
        title="Detalhes do registro"
      />
    );
  }
}

ModalRetornoFilaGet.propTypes = {
  showModal: PropTypes.func,
  handleModal: PropTypes.func,
  retornoFilaGet: PropTypes.objectOf(PropTypes.object).isRequired,
  auth: PropTypes.objectOf(PropTypes.object).isRequired,
}.isRequired;

export default ModalRetornoFilaGet;



// WEBPACK FOOTER //
// ./src/pages/consultas/ModalRetornoFilaGet.jsx